/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { LoginFromProviderEnumType } from './LoginFromProviderEnum'
import { UserAdditionalDetailsModel, UserAdditionalDetailsModelType } from './UserAdditionalDetailsModel'
import { UserAdditionalDetailsModelSelector } from './UserAdditionalDetailsModel.base'
import { UserPushNotificationConfigModel, UserPushNotificationConfigModelType } from './UserPushNotificationConfigModel'
import { UserPushNotificationConfigModelSelector } from './UserPushNotificationConfigModel.base'
import { UserRolesEnumType } from './UserRolesEnum'
import { RootStoreType } from './index'

/**
 * UserBase
 * auto generated base class for the model UserModel.
 */
export const UserModelBase = ModelBase.named('User')
  .props({
    __typename: types.optional(types.literal('User'), 'User'),
    _id: types.identifier,
    additionalDetails: types.union(
      types.undefined,
      types.null,
      types.late(() => UserAdditionalDetailsModel)
    ),
    appState: types.union(types.undefined, types.null, types.string),
    appVersion: types.union(types.undefined, types.null, types.string),
    appleTransactionId: types.union(types.undefined, types.null, types.string),
    auth0Id: types.union(types.undefined, types.null, types.string),
    avatar: types.union(types.undefined, types.null, types.string),
    createdAt: types.union(types.undefined, types.frozen()),
    deletedAt: types.union(types.undefined, types.null, types.frozen()),
    email: types.union(types.undefined, types.null, types.string),
    isGuest: types.union(types.undefined, types.null, types.boolean),
    lastLogin: types.union(types.undefined, types.null, types.frozen()),
    loginFrom: types.union(types.undefined, LoginFromProviderEnumType),
    name: types.union(types.undefined, types.string),
    password: types.union(types.undefined, types.null, types.string),
    phoneNumber: types.union(types.undefined, types.null, types.string),
    pushNotificationConfig: types.union(
      types.undefined,
      types.null,
      types.late(() => UserPushNotificationConfigModel)
    ),
    socialId: types.union(types.undefined, types.null, types.string),
    stripeCustomerId: types.union(types.undefined, types.null, types.string),
    updatedAt: types.union(types.undefined, types.frozen()),
    userRoles: types.union(types.undefined, types.array(UserRolesEnumType))
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class UserModelSelector extends QueryBuilder {
  get _id() {
    return this.__attr('_id')
  }
  get appState() {
    return this.__attr('appState')
  }
  get appVersion() {
    return this.__attr('appVersion')
  }
  get appleTransactionId() {
    return this.__attr('appleTransactionId')
  }
  get auth0Id() {
    return this.__attr('auth0Id')
  }
  get avatar() {
    return this.__attr('avatar')
  }
  get createdAt() {
    return this.__attr('createdAt')
  }
  get deletedAt() {
    return this.__attr('deletedAt')
  }
  get email() {
    return this.__attr('email')
  }
  get isGuest() {
    return this.__attr('isGuest')
  }
  get lastLogin() {
    return this.__attr('lastLogin')
  }
  get loginFrom() {
    return this.__attr('loginFrom')
  }
  get name() {
    return this.__attr('name')
  }
  get password() {
    return this.__attr('password')
  }
  get phoneNumber() {
    return this.__attr('phoneNumber')
  }
  get socialId() {
    return this.__attr('socialId')
  }
  get stripeCustomerId() {
    return this.__attr('stripeCustomerId')
  }
  get updatedAt() {
    return this.__attr('updatedAt')
  }
  get userRoles() {
    return this.__attr('userRoles')
  }
  additionalDetails(
    builder:
      | string
      | UserAdditionalDetailsModelSelector
      | ((selector: UserAdditionalDetailsModelSelector) => UserAdditionalDetailsModelSelector)
      | undefined
  ) {
    return this.__child('additionalDetails', UserAdditionalDetailsModelSelector, builder)
  }
  pushNotificationConfig(
    builder:
      | string
      | UserPushNotificationConfigModelSelector
      | ((selector: UserPushNotificationConfigModelSelector) => UserPushNotificationConfigModelSelector)
      | undefined
  ) {
    return this.__child('pushNotificationConfig', UserPushNotificationConfigModelSelector, builder)
  }
}
export function selectFromUser() {
  return new UserModelSelector()
}

export const userModelPrimitives =
  selectFromUser()._id.appState.appVersion.appleTransactionId.auth0Id.avatar.createdAt.deletedAt.email.isGuest
    .lastLogin.loginFrom.name.password.phoneNumber.socialId.stripeCustomerId.updatedAt.userRoles
